var _document$querySelect;
import { breadthFirstSearch } from "../../../assets/utils/dom";
import * as $18n from '@alife/lazada-i18n';
import React, { useCallback } from "react";
import "./style.scss";

// 可能存在的 header 高度
var headerHeight = ((_document$querySelect = document.querySelector('header')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetHeight) || 0;
var Navigation = function Navigation(_ref) {
  var modules = _ref.modules,
    _ref$container = _ref.container,
    container = _ref$container === void 0 ? null : _ref$container;
  /**
   * 滚动到指定模块
   */
  var scrollToSection = useCallback(function (section) {
    var element = breadthFirstSearch(document.body, "[data-module-id=\"".concat(section, "\"]"));
    if (!element) {
      console.error("cannot find ".concat(section, " element"));
      return;
    }
    if (container) {
      container === null || container === void 0 || container.scrollTo({
        top: (element === null || element === void 0 ? void 0 : element.offsetTop) || 0,
        behavior: 'smooth'
      });
    } else {
      var _document$documentEle, _element$getBoundingC;
      (_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 || _document$documentEle.scrollTo({
        top: window.scrollY + (((_element$getBoundingC = element.getBoundingClientRect) === null || _element$getBoundingC === void 0 || (_element$getBoundingC = _element$getBoundingC.call(element)) === null || _element$getBoundingC === void 0 ? void 0 : _element$getBoundingC.top) || 0) - headerHeight,
        behavior: 'smooth'
      });
    }
  }, [container]);
  return (
    /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "navigation-styles"
    }, /*#__PURE__*/React.createElement("div", {
      className: "quick-nav-title"
    }, /*#__PURE__*/$18n.get('@ali/lago-cms-builder.quickMenu', 'Quick Menu')), /*#__PURE__*/React.createElement("div", {
      className: "quick-nav-content"
    }, modules === null || modules === void 0 ? void 0 : modules.map(function (item) {
      return /*#__PURE__*/React.createElement("div", {
        key: item === null || item === void 0 ? void 0 : item.id,
        className: "quick-nav-box",
        onClick: function onClick() {
          return scrollToSection(item === null || item === void 0 ? void 0 : item.id);
        }
      }, item === null || item === void 0 ? void 0 : item.title);
    }))))
  );
};
export default Navigation;